class WorkspacesApiResponseModel {
  // #region Props
  titulo;
  descripcion;
  guidWorkspace;
  numeroInformes;
  // #endregion

  constructor(object) {
    for (const key in object) {
      if (Object.hasOwnProperty.call(object, key)) {
        const element = object[key];
        this[key] = element;
      }
    }
  }

  // #region Private methods
  // #endregion
}

export default WorkspacesApiResponseModel;
